<script setup lang="ts">
import { useField } from 'vee-validate'
import type { FieldUIProp, UIProp } from '~/types/elementsUi'
import { useInjectedId } from '~/composables/useInjectedId'

interface RadioProps {
  name: string
  label?: string
  value?: string | number
  circle?: boolean
  disabled?: boolean

  ui?: FieldUIProp & UIProp<'checkboxLabel'>
}

defineOptions({
  inheritAttrs: false
})

const props = defineProps<RadioProps>()

const { value: fieldValue, errors } = useField<boolean>(props.name)

const $form = useInjectedId(props.name)

const color = computed(() => {
  if (errors.value.length > 0) {
    return 'danger'
  } else if (errors.value.length === 0) {
    return 'success'
  }
  return undefined
})
</script>

<template>
  <VField
    :ui="{
      field: ui?.field,
      control: ui?.control
    }"
    :color
    :message="errors.join('\n')"
  >
    <!-- Note: Be careful with not mixing up fieldValue and value here! -->
    <VCheckbox
      v-model="fieldValue"
      v-bind="$attrs"
      :label
      :value="value ?? 'value'"
      :id-key="$form.elementId.value"
      :circle
      :disabled
      :ui="{
        label: ui?.label,
        checkboxLabel: ui?.checkboxLabel
      }"
    >
      <slot />
    </VCheckbox>
  </VField>
</template>

<style scoped></style>
